import { render, staticRenderFns } from "./PublicNotice.vue?vue&type=template&id=6dd2ab44&"
import script from "./PublicNotice.vue?vue&type=script&lang=js&"
export * from "./PublicNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports